import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchBoxscoreFeedDataById = args => {
    return doDefaultFetch(`/site/api/boxscore/${args.gameId}`, args);
};

export default {
    fetchBoxscoreFeedDataById,
};
